import React from 'react';
import styled from 'styled-components';
import { githubLink } from '../../config';

const FooterCtn = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  margin-bottom: 0;
  bottom: 3px;
  .footer-text{
    font-weight: 400;
    margin-bottom: 0;
  }
  a{
    text-decoration: none;
    color: #35a16d;
    transition: 300ms linear 0s;
    :hover{
      color: #54f8a5;
    }
  }
`;

function Footer() {
  return (
    <FooterCtn>
      <h5 className="footer-text">
        {' '}
        Designed & Built with ♥️ by
        {' '}
        <a href={githubLink}>kosher9</a>
      </h5>
    </FooterCtn>
  );
}

export default Footer;
